module.exports = __webpack_public_path__ + "img/mobilereportforrepair2.d9d8eb70.png";